// Who a stock return is about (Batch206, 2026-10-09: "showing stock out number instead of
// customer or employee name"). A supplier return names its supplier; a stock-out based return
// names whoever that Stock Out was issued to - employee or customer.
export const returnPartyName = (r) =>
  r?.supplierName ||
  (r?.issuedToType === "EMPLOYEE" ? r?.issuedToEmployeeName : r?.issuedToCustomerName) ||
  r?.issuedToEmployeeName ||
  r?.issuedToCustomerName ||
  null;

export const returnPartyKind = (r) =>
  r?.supplierName ? "Supplier" : r?.issuedToType === "EMPLOYEE" ? "Employee" : r?.issuedToType === "CUSTOMER" ? "Customer" : null;
